import { render, staticRenderFns } from "./IconCalculator.vue?vue&type=template&id=512c3345&"
import script from "./IconCalculator.vue?vue&type=script&lang=js&"
export * from "./IconCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports